// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GetWorkflowsRequestModel {
    'accountId': number;
    'includePayors'?: boolean;
    'includePharmacies'?: boolean;
    'includePrescribers'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GetWorkflowsRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "includePayors",
            "baseName": "includePayors",
            "type":     "boolean"
        },
        {
            "name":     "includePharmacies",
            "baseName": "includePharmacies",
            "type":     "boolean"
        },
        {
            "name":     "includePrescribers",
            "baseName": "includePrescribers",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return GetWorkflowsRequestModel.attributeTypeMap;
    }
}
